// extracted by mini-css-extract-plugin
export default {"wrapper":"L6-z","message":"M6-z","image":"N6-z"};